// extracted by mini-css-extract-plugin
export default {"brand_small_slider":"style_brand_small_slider__V5pRu","brand_small_banners_item":"style_brand_small_banners_item__7F-Ta","slider_image":"style_slider_image__svgov"};